// extracted by mini-css-extract-plugin
export default {"wrapper":"Timeline_wrapper__-LMeu","timeline":"Timeline_timeline__ohMav","info":"Timeline_info__fLGrX","image":"Timeline_image__XlcEW","result":"Timeline_result__s9pRU"};